import { createAction } from '@reduxjs/toolkit';
import { CHNode } from '../../../general/node';

export const deleteButtonClicked = createAction<void, 'creativeHub/remover/DELETE_BUTTON_CLICKED'>(
  'creativeHub/remover/DELETE_BUTTON_CLICKED',
);
export const modalOpenedUiEvent = createAction<void, 'creativeHub/remover/MODAL_OPENED_UI_EVENT'>(
  'creativeHub/remover/MODAL_OPENED_UI_EVENT',
);
export const modalOpened = createAction<
  { folders: number; files: number },
  'creativeHub/remover/MODAL_OPENED'
>('creativeHub/remover/MODAL_OPENED');

export const modalClosed = createAction<void, 'creativeHub/remover/MODAL_CLOSED'>(
  'creativeHub/remover/MODAL_CLOSED',
);
export const modalCloseUiEvent = createAction<void, 'creativeHub/remover/MODAL_CLOSE_UI_EVENT'>(
  'creativeHub/remover/MODAL_CLOSE_UI_EVENT',
);
export const deleteStarted = createAction<
  { nodeID: number; bulkJobID: string },
  'creativeHub/remover/DELETE_STARTED'
>('creativeHub/remover/DELETE_STARTED');
export const bulkJobFinished = createAction<
  {
    bulkJobID: string;
    results: {
      node: CHNode;
      nodeID: number;
      success: boolean;
    }[];
  },
  'creativeHub/remover/BULK_JOB_FINISHED'
>('creativeHub/remover/BULK_JOB_FINISHED');
export const bulkJobStarted = createAction<
  { bulkJobID: string },
  'creativeHub/remover/BULK_JOB_STARTED'
>('creativeHub/remover/BULK_JOB_STARTED');

export const deleteError = createAction<
  { error: any; nodeID: number; bulkJobID: string },
  'creativeHub/remover/DELETE_ERROR'
>('creativeHub/remover/DELETE_ERROR');

export const deleteSuccess = createAction<
  { result: any; nodeID: number; bulkJobID: string },
  'creativeHub/remover/DELETE_SUCCESS'
>('creativeHub/remover/DELETE_SUCCESS');
